var $class="se2--wiztopic-event-list--wiztopic-card",$name="WiztopicEventList/wiztopicCard",$path="app/components/WiztopicEventList/partials/wiztopicCard/index.js",$this={$class,$name,$path,};import shell from 'app/modules/shell';
import setYoutubeVideoThumbnail from 'app/utilities/setYoutubeVideoThumbnail';
import lazyHandleOpenModalButtons from 'app/components/utilities/lazyHandleOpenModalButtons';

const videoSelector = `.${$class} video`;

export default shell.registerComponent($this, ({
  addEventListener, mount, settings, configs,
}) => {
  const onMouseEnter = ({ target }) => {
    !settings.accessibility && target?.querySelector(videoSelector).play();
  };

  const onMouseLeave = ({ target }) => {
    target?.querySelector(videoSelector).pause();
  };

  mount((element) => {
    if (element.classList.contains('card-with-video')) {
      addEventListener(element, 'mouseenter', onMouseEnter);
      addEventListener(element, 'mouseleave', onMouseLeave);
    }

    setYoutubeVideoThumbnail(element, configs.css.classNames.videoThumbnail);

    lazyHandleOpenModalButtons(addEventListener, element, [configs.css.classNames.videoThumbnail]);
  });
});
